// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"712":"08f8373b","719":"a45e83d9","755":"e7e97e43"}[chunkId] + ".chunk.js";
};